<template>
<v-combobox
:label="label"
v-model="selection"
:disabled="isUpdating"
:items="items"
item-value="id"
cache-items
:search-input.sync="search"
:filter="filter"
box
chips
multiple>
	<template
	slot="no-data">
		<v-list-tile v-if="search">
			<v-list-tile-content>
				<v-list-tile-title>
					<em>Press <kbd>ENTER</kbd> or <kbd>TAB</kbd> to create the item </em>“{{search}}”
				</v-list-tile-title>
			</v-list-tile-content>
		</v-list-tile>
	</template>


	<template
	slot="selection"
	slot-scope="data">
		<v-chip
		:selected="data.selected"
		close
		class="chip--select-multi"
		@input="data.parent.selectItem(data.item)">
			<v-avatar v-if="data.item.data.thumbnailUrl">
				<img :src="data.item.data.thumbnailUrl">
			</v-avatar>
			{{ data.item.displayName() }}
		</v-chip>

	</template>

	<template
	slot="item"
	slot-scope="data">
		<template v-if="!(data.item instanceof Object)">
			<v-list-tile-content v-text="data.item"></v-list-tile-content>
		</template>

		<template v-else>
			<v-list-tile-content>
				<v-list-tile-title v-html="data.item.displayName()"></v-list-tile-title>
				<v-list-tile-sub-title v-html="data.item.memberOf.map(m => m.data.name).join(', ')"></v-list-tile-sub-title>
			</v-list-tile-content>
			<v-list-tile-avatar>
				<img v-if="data.item.data.thumbnailUrl" :src="data.item.data.thumbnailUrl">
			</v-list-tile-avatar>
		</template>
	</template>
</v-combobox>
</template>

<script>
import { Entity } from '@/assets/js/JMan/Entity'
import { jman } from '@/services/jman'

export default {
	name: "JmCombobox",

	props: {
		type: [ String ],
		label: String,
		value: [ Object, Array, String, Number, Boolean ],
		multiple: [ Boolean, Number ]
	},

	data () {
		return {
			isUpdating: false,
			selection: [],
			items: [],
			search: null
		}
	},

	watch: {
		search (value) {
			if (value) {
				this.query(value);
			}
		},

		selection (value, previous) {

			if (this.maxItems && value.length > this.maxItems) {
				this.$nextTick( () => this.selection = this.selection.splice(-this.maxItems) );
			}

			if (value.length != previous.length) {

				this.selection = value.map(item => {
					if (typeof item === 'string') {
						item = Entity.make({type: this.type, data: {name: item}}, jman);
					}
					return item;
				});
			}

			this.$emit('input', this.multiple? value : value[0]);
		}
	},

	computed: {

		maxItems () {
			return this.multiple
				? typeof this.multiple == 'number'
					? Math.abs(this.multiple)
					: null
				: 1;
		}
	},

	methods: {
		query (value) {
			this.isUpdating = true;
			const entities = this.$store.state.jman.entities;
			const items = entities.filter(e => e.type == this.type && e.match(new RegExp(value, "i")));
			this.items = items;
			this.isUpdating = false;
		},

		filter (item, queryText, itemText) {
			return item.match(new RegExp(queryText, "i"));
		}
	}


}
</script>



// WEBPACK FOOTER //
// src/components/widgets/InputWidgets/Combobox.vue